import { actionGenerator } from '../../utils/redux/actionGenerator';
import {
  EQuestionsActionTypes,
  ISetAnswersVisibilityPayload,
  TSetAnswersVisibility,
  ISetAnswersPagePayload,
  TSetAnswersPage,
  ISetQuestionsPayload,
  TSetQuestions,
  TSetLoading,
  TSetQuestionsPagination,
  IAddAnswersToQuestionPayload,
  TAddAnswersToQuestion,
  TSetQuestionReactionPayload,
  TSetQuestionReaction,
} from './types';

export const setQuestions: (payload: ISetQuestionsPayload) => TSetQuestions = actionGenerator<
  EQuestionsActionTypes.SetQuestions,
  ISetQuestionsPayload
>(EQuestionsActionTypes.SetQuestions);

export const setLoading: (payload: boolean) => TSetLoading = actionGenerator<EQuestionsActionTypes.SetLoading, boolean>(
  EQuestionsActionTypes.SetLoading,
);

export const setQuestionsPagination: (payload: ISetQuestionsPayload) => TSetQuestionsPagination = actionGenerator<
  EQuestionsActionTypes.SetQuestionsPage,
  ISetQuestionsPayload
>(EQuestionsActionTypes.SetQuestionsPage);

export const setAnswersVisibility: (payload: ISetAnswersVisibilityPayload) => TSetAnswersVisibility = actionGenerator<
  EQuestionsActionTypes.SetAnswersVisibility,
  ISetAnswersVisibilityPayload
>(EQuestionsActionTypes.SetAnswersVisibility);

export const addAnswersToQuestion: (payload: IAddAnswersToQuestionPayload) => TAddAnswersToQuestion = actionGenerator<
  EQuestionsActionTypes.AddAnswersToQuestion,
  IAddAnswersToQuestionPayload
>(EQuestionsActionTypes.AddAnswersToQuestion);

export const setQuestionsPage: (payload: ISetAnswersPagePayload) => TSetAnswersPage = actionGenerator<
  EQuestionsActionTypes.SetAnswersPage,
  ISetAnswersPagePayload
>(EQuestionsActionTypes.SetAnswersPage);

export const setQuestionsReactionAction: (payload: TSetQuestionReactionPayload) => TSetQuestionReaction =
  actionGenerator<EQuestionsActionTypes.SetQuestionReaction, TSetQuestionReactionPayload>(
    EQuestionsActionTypes.SetQuestionReaction,
  );
